import { IAppRequest } from 'src/typings/app';
import { IAction } from 'src/typings/index';
import { ActionTypes } from './actions';

export interface IAppRequestReducer {
  isLoading: boolean;
  error: Error | null;
  data: IAppRequest | undefined;
}

export const initialState: IAppRequestReducer = {
  isLoading: true,
  error: null,
  data: undefined,
};

export const appRequestReducer = (
  state = initialState,
  { type, payload }: IAction,
): IAppRequestReducer => {
  switch (type) {
    case ActionTypes.GET_APP_DATA_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case ActionTypes.GET_APP_DATA_RESET: {
      return {
        ...initialState,
      };
    }

    case ActionTypes.GET_APP_DATA_REQUEST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        data: payload,
      };
    }

    case ActionTypes.GET_APP_DATA_REQUEST_FAIL: {
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    }

    default:
      return state;
  }
};
